import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreTileIcons from './StoreTileIcons.js';

const StoreTileIconsContainer = ({ icons  })=>{
    const { getLabel  } = useIntl();
    const labels = {
        wheelchairAccessible: getLabel('locations.component.storeTileIcons.wheelchairAccessible'),
        hearingAppointmentPossible: getLabel('locations.component.storeTileIcons.hearingAppointmentPossible')
    };
    const enabledIcons = Object.keys(icons).filter((name)=>icons[name]
    );
    if (!enabledIcons) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreTileIcons, {
        labels: labels,
        icons: enabledIcons
    });
};

export { StoreTileIconsContainer as default };
//# sourceMappingURL=StoreTileIconsContainer.js.map
